import { hasOrgFeature, type OrgType } from './org-features.js';

/**
 * SIL-2534: where a signed-in org lands from `/`. A table keyed on the full
 * OrgType set, not an `orgType === 'x'` compare: adding an org type is a
 * compile error here until it states its landing screen.
 *
 * The table says what an org type WANTS; `orgLandingPath` still requires the
 * org to hold the `marketIntel` feature for the workbench, so the access
 * decision stays in `hasOrgFeature` and a table typo can never route an org
 * onto a section it is denied.
 */
export type OrgLandingPath = '/dashboard' | '/market-intelligence';

const ORG_LANDING_PREFERENCE: Record<OrgType, OrgLandingPath> = {
  business: '/dashboard',
  individual: '/dashboard',
  broker: '/dashboard',
  reseller: '/market-intelligence', // buy-side margin workbench
};

/** Fail-safe: null/unknown org type, or a preference the org cannot access, lands on /dashboard. */
export function orgLandingPath(orgType: OrgType | null | undefined): OrgLandingPath {
  if (orgType == null) return '/dashboard';
  const preferred = Object.prototype.hasOwnProperty.call(ORG_LANDING_PREFERENCE, orgType)
    ? ORG_LANDING_PREFERENCE[orgType]
    : '/dashboard';
  if (preferred === '/market-intelligence' && !hasOrgFeature(orgType, 'marketIntel')) return '/dashboard';
  return preferred;
}
